'use client'

import { useEffect } from 'react'
import { m, useReducedMotion } from 'framer-motion'
import { Home } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/navigation'
import SpaceBackdrop from '@/components/world/SpaceBackdrop'

export default function NotFoundPageClient() {
  const t = useTranslations('notFound')
  const reduce = useReducedMotion()
  const metaTitle = t('metaTitle')

  // Next.js keeps the layout's title on not-found responses, so set the tab title here.
  useEffect(() => {
    document.title = `${metaTitle} | M2B Solutions`
  }, [metaTitle])

  return (
    <div className="relative flex min-h-[70svh] items-center justify-center overflow-x-clip px-6 pt-8 pb-24">
      <SpaceBackdrop />

      <m.div
        initial={reduce ? false : { opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, type: 'spring', bounce: 0.3 }}
        className="relative z-10 max-w-xl text-center"
      >
        <p className="mb-2! [font-family:var(--font-display)] text-8xl text-[var(--flagship-cyan)] sm:text-9xl">
          404
        </p>
        <h1 className="mb-4! [font-family:var(--font-display)] text-3xl text-[var(--flagship-text)] sm:text-5xl">
          {t('title')}
        </h1>
        <p className="mb-8! text-lg text-[var(--flagship-muted)]">{t('text')}</p>
        <Link
          href="/"
          className="relative inline-flex items-center gap-2 overflow-hidden rounded-full border border-white/25 bg-white/[0.05] px-6 py-3 [font-family:var(--font-ui)] font-bold text-[var(--flagship-text)] backdrop-blur-xl transition-colors hover:bg-white/[0.10] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-300"
          style={{
            boxShadow:
              'inset 0 1px 0 0 rgba(255,255,255,0.35), inset 0 0 0 1px rgba(255,255,255,0.08), inset 0 0 24px -14px #22d3ee, 0 10px 30px -14px rgba(34,211,238,0.45)',
          }}
        >
          <Home className="h-5 w-5 text-[var(--flagship-cyan)]" />
          {t('backToHome')}
        </Link>
      </m.div>
    </div>
  )
}
